import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=18ffb96a"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"
import style0 from "./SidebarHeader.vue?vue&type=style&index=0&id=18ffb96a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports